module.exports = __webpack_public_path__ + "static/media/Capture.afaf9838.PNG";